var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2777 20.967C26.1582 20.7261 25.2726 21.2459 24.4884 21.6998C23.6853 22.1676 22.1583 23.4064 21.2829 23.0893C16.8015 21.2442 12.5866 17.3217 10.762 12.8223C10.4404 11.9283 11.6734 10.3915 12.1377 9.57892C12.5883 8.79234 13.0973 7.89834 12.8651 6.77045C12.6553 5.75691 9.9417 2.30394 8.98213 1.3597C8.34929 0.735982 7.70097 0.392937 7.03546 0.337495C4.53334 0.230077 1.73887 3.5687 1.24876 4.36741C0.0209161 6.0705 0.0277948 8.33668 1.2694 11.0845C4.26163 18.4652 15.5788 29.6037 22.9871 32.7085C24.3543 33.3478 25.6045 33.6683 26.7274 33.6683C27.8263 33.6683 28.8048 33.3616 29.6457 32.7535C30.2803 32.3879 33.7557 29.4547 33.6646 26.8854C33.6096 26.2305 33.2673 25.5756 32.6517 24.9414C31.7145 23.9729 28.2837 21.1783 27.2777 20.967Z",
    fill: "#4E5D78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDark);
export default __webpack_public_path__ + "static/media/phoneDark.239adb02.svg";
export { ForwardRef as ReactComponent };